//@flow

import React from 'react';
import { Link } from 'react-router-dom';
import capitalize from 'lodash/capitalize';
import type { Node } from 'react';
import { CardTitle } from 'reactstrap';

import { truncateText } from '../../../lib/utils';
import { IconForCards as Icon } from '../../../constants/icons';
import { LETTER_COUNT_FOR_TITLE } from '../../../constants/lettersCount';

type CardBodyTopProps = {
  children: Node,
  onClick?: Function,
  title: string,
  type: string,
  url?: string | null,
  doesOpenInNewTab?: boolean,
};

export default function CardBodyTop(props: CardBodyTopProps) {
  const { children, onClick, title, type, url } = props;
  const iconClassName: string = Icon[type];
  const AnchorElement = url ? Link : 'a';

  return (
    <div className="cardBodyTop">
      <CardTitle onClick={onClick} title={title}>
        {/* spaces is necessary. Don`t delete it */}
        <i className={iconClassName} />{' '}
        {title ? (
          <AnchorElement to={url}>
            {capitalize(truncateText(title, LETTER_COUNT_FOR_TITLE))}
          </AnchorElement>
        ) : null}
      </CardTitle>
      {children}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Cards/Common/CardBodyTop.jsx